// Utility functions for tracking user preferences
export const LocationInfoTracker = {
  // Check if user has seen the location info modal
  hasSeenLocationInfo(): boolean {
    // Check localStorage first
    const localStorageSeen =
      localStorage.getItem("locationInfoSeen") === "true";

    // Check cookie as backup
    const cookieSeen =
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("locationInfoSeen="))
        ?.split("=")[1] === "true";

    return localStorageSeen || cookieSeen;
  },

  // Mark that user has seen the location info modal
  markLocationInfoSeen(): void {
    // Save to localStorage
    localStorage.setItem("locationInfoSeen", "true");

    // Save to cookie (expires in 1 year)
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    document.cookie = `locationInfoSeen=true; expires=${expires.toUTCString()}; path=/`;
  },

  // Reset tracking (for testing purposes)
  resetLocationInfoTracking(): void {
    localStorage.removeItem("locationInfoSeen");
    document.cookie =
      "locationInfoSeen=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
};
